module.exports = __webpack_public_path__ + "img/banner-panels.fc1e4865.svg";